import { activePortalRegion } from '../config/portal-regions';
export type SignInRoute = {
  p: string;
  d?: string;
  n?: string;
  t?: string;
  u?: string | null;
};

export async function fetchAuthSignInHint(email: string): Promise<{ r: SignInRoute | null }> {
  const publicApiBase = (activePortalRegion.publicApiUrl || (activePortalRegion.id === 'us' ? import.meta.env.VITE_PUBLIC_API_URL : 'https://regional-endpoint-not-configured.invalid')) || '';
  if (!publicApiBase || !email.trim()) {
    return { r: null };
  }

  try {
    const response = await fetch(`${publicApiBase}/auth-sign-in-hint`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.trim().toLowerCase() }),
    });
    if (!response.ok) {
      return { r: null };
    }
    const data = await response.json();
    const route = data?.r;
    if (!route?.p) {
      return { r: null };
    }
    return { r: route as SignInRoute };
  } catch {
    return { r: null };
  }
}
